import React from 'react';
import { Link } from 'react-router-dom';

export default ({ condition, link, children }) =>
  condition ? <Link to={link}>{children}</Link> : children;